/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Result_TitleInputs */

const vi_import_result_title = /** @type {(inputs: Import_Result_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kết quả import`)
};

/**

* @param {Import_Result_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_result_title = /** @type {((inputs?: Import_Result_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Result_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_result_title(inputs)
});